import { PHONES_TO_BLACKLIST } from '../../config'

export function setDuplicatedlabels(event) {
  const { value } = event.target

  if (!PHONES_TO_BLACKLIST.includes(value)) {
    window.deduplicateWindowValue = '7d'
    window.deduplicateLabelValue = window._satellite.getVar('digitalData.page.pageinfo.IDlanding')
    return
  }

  window.deduplicateWindowValue = ''
  window.deduplicateLabelValue = ''
}
